import login from './views/login/login.vue'
import reg from './views/login/register.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import main from './views/main/main.vue'
import user from './views/member/list/user.vue'

let routes = [
    {    //服务登记表
	    path: '/serverTable/:id',
	    component:() => import("@/views/service/serverTable.vue"),
	    name: 'serverTable',
	    hidden: true
	},
    {    //诊疗登记表
	    path: '/medicalTable/:id',
	    component:() => import("@/views/service/diagnosis/medicalTable.vue"),
	    name: 'medicalTable',
	    hidden: true
	},
	 {    //寄养协议
	    path: '/agreement/:id',
	    component:() => import("@/views/service/agreement.vue"),
	    name: 'agreement',
	    hidden: true
	},
    {
        path: '/login',
        // component: login,
		component:() => import("@/views/login/login.vue"),
        name: 'login',
        hidden: true
    },
    {
        path: '/regs',
        component:reg,
        name: 'reg',
        hidden: true
    },
    {
        path: '/forget',
        component:() => import("@/views/login/forgetPassword.vue"),
        name: 'forget',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '404',
        hidden: true
    },
    {
        path:'/select',
        component:() => import("@/views/user/selectShop.vue"),
        name:'select',
        hidden:true,
    },
    {
        path:'/industry',
        component:() => import("@/views/user/industryList.vue"),
        name:'industry',
        hidden:true,
    },
    {
        path:'/create/:id',
        component:() => import("@/views/user/createShop.vue"),
        name:'create',
        hidden:true,
    },
	{
        path:'/successful',
        component:() => import("@/views/user/createShopSuccessful.vue"),
        name:'successful',
        hidden:true,
    },
    {
        path:'/cashier/:uid',
        component:() => import("@/views/main/cashier.vue"),
        name:'收银付款',
        hidden:true,
    },
    {
		id:'1',
        path: '/main',
        component: Home,
        name: '工作台',
        iconCls: 'el-icon-s-platform',
				redirect: { path: '/main/serviceList' },
        children: [
					 { id:'49',path: '/main/cashier', component:() => import("@/views/main/main"), name: '收银台',hidden: true},
                     { id:'50',path: '/main/serviceList', component:() => import("@/views/main/serviceList.vue"), name: '服务列表',hidden: true},
                     { id:'',path: '/main/addConsume', component:() => import("@/views/main/addConsume"), name: '新增消费',hidden: true},
        ],
		hidden: true
    },


//    {
//   id:'1',
//         path: '/main',
//         component: Home,
//         name: '工作台',
//         iconCls: 'el-icon-s-platform',
//         redirect: { path: '/main/cashier' },
//         children: [
// 	{ path: '/main/list', component: main, name: '主页'}
//     { id:'50',path: '/main/cashier', component:() => import("@/views/main/main"), name: '收银台',hidden: true},
//     { id:'51',path: '/main/serviceList', component:() => import("@/views/main/serviceList.vue"), name: '服务列表',hidden: true},
//       ],
// 		hidden: true
//     },

	{
		id:'2',
        path: '/user',
		component: Home,
        name: '会员管理',
        iconCls: 'el-icon-user-solid',
        redirect: { path: '/user/list' },
        children: [
            { id:'10',path: '/user/list', component:() => import("@/views/member/list/user.vue"), name: '会员列表',hidden: true},
            { id:'',path: '/user/list/:id', component:() => import("@/views/member/list/userInfo.vue"), name: '会员详情',hidden: true},
            { id:'11',path: '/user/setting',component:()=> import("@/views/member/settings/settings"),name:'会员设置',hidden: true},
            { id:'',path: '/user/setting/:id',component:() => import("@/views/member/settings/settingsData"),name:'会员等级',hidden: true},
            { id:'',path: '/user/growTask',component:()=> import("@/views/member/settings/growTask"),name:'管理成长任务',hidden: true},
            { id:'',path: '/user/setting/rechargeRule',component:()=> import("@/views/member/settings/rechargeRule"),name:'管理充值规则',hidden: true},
            { id:'45',path: '/user/import',component:()=> import("@/views/member/import/userImport"),name:'会员导入',hidden: true},
            { id:'',path: '/user/importError/:id',component:()=> import("@/views/member/import/errorImport"),name:'会员导入失败',hidden: true},
        ],
		hidden: true
	},
	// {
	// 	id:'3',
	//     path: '/order',
	//     component: Home,
	//     name: '订单管理',
	// 		index:1,
	//     iconCls: 'el-icon-s-order',
	// 		redirect: { path: '/order/list' },
	//     children: [
	//         {id:'12',path: '/order/list', component:() => import("@/views/main3/main3.vue"), name: '订单列表',hidden: true},
	//         {id:'',path: '/order/list/:order_sn', component:() => import("@/views/main3/main3.vue"), name: '订单详情',hidden: true},
	//     ],
	// 	hidden: true
	// },
		{
		id:'3',
	    path: '/order',
	    component: Home,
	    name: '订单管理',
			index:1,
	    iconCls: 'el-icon-s-order',
			redirect: { path: '/order/list' },
	    children: [
	        {id:'12',path: '/order/list', component:() => import("@/views/order/order.vue"), name: '订单列表',hidden: true},
	        {id:'',path: '/order/list/:order_sn', component:() => import("@/views/order/orderInfo.vue"), name: '订单详情',hidden: true},
	    ],
		hidden: true
	},
	{
		id:'4',
	    path: '/service',
	    component: Home,
	    name: '业务管理',
	    iconCls: 'el-icon-s-opportunity',
			redirect: { path: '/service/list'},
	    children: [
			{ id:'13',path: '/service/list', component:() => import("@/views/service/service.vue"), name: '洗护美容',hidden: true},
			{ id:'17',path: '/service/foster', component:() => import("@/views/service/foster.vue"), name: '寄养服务',hidden: true},
			{ id:'14',path: '/service/goods', component:() => import("@/views/service/goods.vue"), name: '门店商品',hidden: true},
			{ id:'15',path: '/service/card', component:() => import("@/views/service/card.vue"), name: '服务卡项',hidden: true},
			{ id:'42',path: '/service/rechargeRule', component:() => import("@/views/member/settings/rechargeRule.vue"), name: '充值业务',hidden: true},
			{ id:'18',path: '/service/diagnosis', component:() => import("@/views/service/diagnosis/list.vue"), name: '诊疗服务',hidden: true,
				// children: [
					// { path: '/', component:() => import("@/views/service/diagnosis/list.vue"), name: ''},
					// { path: '/service/diagnosis/drug', component:() => import("@/views/service/diagnosis/drug/drug.vue"), name: '药品管理'},
					// { path: '/service/diagnosis/addDrug', component:() => import("@/views/service/diagnosis/drug/addDrug.vue"), name: '新增药品'},
					// { path: '/service/diagnosis/editDrug', component:() => import("@/views/service/diagnosis/drug/editDrug.vue"), name: '编辑药品'},
					// { path: '/service/diagnosis/item', component:() => import("@/views/service/diagnosis/item/item.vue"), name: '项目管理'},
					// { path: '/service/diagnosis/doctor', component:() => import("@/views/service/diagnosis/doctor/doctor.vue"), name: '医师诊疗'},
				// ]
			},
			{ id:'46',path: '/service/stock', component:() => import("@/views/goods/stock/list.vue"), name: '库存管理',hidden: true},
			{ path: '/service/stock/storage', component:() => import("@/views/goods/stock/storage/list.vue"), name: '入库'},
			{ path: '/service/stock/outgoing', component:() => import("@/views/goods/stock/outgoing/list.vue"), name: '出库'},
			{ path: '/service/stock/storage/add', component:() => import("@/views/goods/stock/storage/add.vue"), name: '新增入库单'},
			{ path: '/service/stock/outgoing/add', component:() => import("@/views/goods/stock/outgoing/add.vue"), name: '新增出库单'},
			{ path: '/service/diagnosis/drug', component:() => import("@/views/service/diagnosis/drug/drug.vue"), name: '药品管理'},
			{ path: '/service/diagnosis/addDrug', component:() => import("@/views/service/diagnosis/drug/addDrug.vue"), name: '新增药品'},
			{ path: '/service/diagnosis/editDrug', component:() => import("@/views/service/diagnosis/drug/editDrug.vue"), name: '编辑药品'},
			{ path: '/service/diagnosis/model', component:() => import("@/views/service/diagnosis/model/model.vue"), name: '诊断模板管理'},
			{ path: '/service/diagnosis/item', component:() => import("@/views/service/diagnosis/item/item.vue"), name: '项目管理'},
			{ path: '/service/diagnosis/doctor', component:() => import("@/views/service/diagnosis/doctor/doctor.vue"), name: '医师诊疗'},
			// { id:'16',path: '/service/living', component:() => import("@/views/service/living.vue"), name: '活体',hidden: true},
			{ id:'',path: '/service/list/id', component:() => import("@/views/service/living.vue"), name: '详情',hidden: true},
			{ id:'',path: '/service/list/add', component:() => import("@/views/service/addService.vue"), name: '新增服务',hidden: true},
			{ id:'',path: '/service/goods/add', component:() => import("@/views/service/addGoods.vue"), name: '新增商品',hidden: true},
			{ id:'',path: '/service/card/add/', component:() => import("@/views/service/addCard.vue"), name: '新增卡项',hidden: true},
			{ id:'',path: '/service/goods/import', component:() => import("@/views/service/importGoods/importGoods.vue"), name: '商品导入',hidden: true},
			{ id:'',path: '/service/goods/import/:id', component:() => import("@/views/service/importGoods/importGoodsError.vue"), name: '商品导入失败',hidden: true},
	    ],
		hidden: true
	},
	// {
	// 	id:'5',
	// 	path: '/petcloud',
	// 	component: Home,
	// 	name: '宠物云',
	// 	iconCls: 'el-icon-cloudy',
	// 	redirect: { path: '/petcloud/goods'},
	// 	children: [
	// 			{ id:'19',path: '/petcloud/goods', component:() => import("@/views/petcloud/goods.vue"), name: '宠物商品',hidden: true},
	// 			{ id:'20',path: '/petcloud/livingBody', component:() => import("@/views/petcloud/livingBody.vue"), name: '宠物活体',hidden: true},
	// 			{ id:'21',path: '/petcloud/petCourse', component:() => import("@/views/petcloud/petCourse.vue"), name: '宠物课程',hidden: true},
	// 			{ id:'22',path: '/petcloud/petInsurance', component:() => import("@/views/petcloud/petInsurance.vue"), name: '宠物保险',hidden: true},
	// 			{ id:'23',path: '/petcloud/petFinancial', component:() => import("@/views/petcloud/petFinancial.vue"), name: '宠物金融',hidden: true}
	// 	],
	// 	hidden: true
	// },
	{
		id:'5',
		path: '/petcloud',
		component: Home,
		name: '营销插件',
		iconCls: 'el-icon-cloudy',
		redirect: { path: '/petcloud/plug'},
		children: [
				{ id:'29',path: '/petcloud/plug', component:() => import("@/views/marketing/plug/plug.vue"), name: '营销插件 ',hidden: true},
				{ id:'',path: '/marketing/plug/coupon', component:() => import("@/views/marketing/coupon.vue"), name: '优惠券',hidden: true},
				{ id:'',path: '/marketing/plug/memberPrice', component:() => import("@/views/marketing/plug/memberPrice.vue"), name: '会员价',hidden: true},
				{ id:'',path: '/marketing/plug/addDiscount', component:() => import("@/views/marketing/addDiscount.vue"), name: '  新增优惠券',hidden: true},
				{ id:'',path: '/marketing/plug/couponrule', component:() => import("@/views/marketing/couponrule.vue"), name: '发券宝',hidden: true},
				{ id:'',path: '/marketing/plug/addCouponrule', component:() => import("@/views/marketing/addCouponrule.vue"), name: '新增发券',hidden: true},
		],
		hidden: true
	},
	{
		id:'6',
		path: '/finance',
		component: Home,
		name: '财务报表',
		iconCls: 'el-icon-s-data',
		redirect: { path: '/finance/list' },
		children: [
				{ id:'24',path: '/finance/list', component:() => import("@/views/finance/operationReport.vue"), name: '经营报表',hidden: true},
				{ id:'43',path: '/finance/capitalReport', component:() => import("@/views/finance/capitalReport.vue"), name: '资金报表',hidden: true},
				{ id:'44',path: '/finance/memberReport', component:() => import("@/views/finance/memberReport.vue"), name: '会员报表',hidden: true},
				{ id:'41',path: '/finance/miniReport', component:() => import("@/views/finance/miniReport.vue"), name: '小程序数据',hidden: true},
				{ id:'42',path: '/finance/bonus', component:() => import("@/views/finance/bonus.vue"), name: '员工提成',hidden: true},
		],
		hidden: true
	},
	{
		id:'7',
		path: '/marketing',
		component: Home,
		name: '线上店铺',
		// 营销插件
		iconCls: 'el-icon-s-marketing',
		redirect: { path: '/marketing/list' },
		children: [
				{ id:'25',path: '/marketing/list', component:() => import("@/views/marketing/marketing.vue"), name: '店铺创建',hidden: true},
				{ id:'',path: '/marketing/mini/main', component:() => import("@/views/marketing/mini/main.vue"), name: '微信小程序页面',hidden:true},
				{ id:'',path: '/marketing/mini/complete', component:() => import("@/views/marketing/mini/complete.vue"), name: '微信小程序数据',hidden:true},
				{ id:'',path: '/marketing/mini/category', component:() => import("@/views/marketing/mini/category.vue"), name: '微信小程序分类',hidden:true},
				{ id:'',path: '/marketing/mini/nick', component:() => import("@/views/marketing/mini/nick.vue"), name: '微信小程序昵称',hidden:true},
				{ id:'',path: '/marketing/mini/register', component:() => import("@/views/marketing/mini/register.vue"), name: '微信小程序认证',hidden:true},
				{ id:'',path: '/marketing/mini/error', component:() => import("@/views/marketing/mini/miniError.vue"), name: '认证失败',hidden:true},
				{ id:'',path: '/marketing/mini/audit', component:() => import("@/views/marketing/mini/audit.vue"), name: '审核中',hidden:true},
				{ id:'26',path: '/marketing/shop', component:() => import("@/views/marketing/shop.vue"), name: '店铺装修',hidden: true},
				{ id:'39',path: '/marketing/shopInfoSMS', component:() => import("@/views/setting/shopInfoSMS.vue"), name: '店铺信息'},  //店铺信息
				{ id:'40',path: '/marketing/storySMS', component:() => import("@/views/setting/storySMS.vue"), name: '店铺简介'},
				{ id:'27',path: '/marketing/goodsMain', component:() => import("@/views/marketing/goods.vue"), name: '上架管理',hidden: true,
				// 菜单名字在marketing/goods.vue 里面配置
				children: [
						{ id:'27',path: '/marketing/goodsGoods', component:() => import("@/views/marketing/goods/goods.vue"), name: '商品',hidden: true},
						{ id:'27',path: '/marketing/goodsService', component:() => import("@/views/marketing/goods/service.vue"), name: '洗护美容 ',hidden: true},
						{ id:'27',path: '/marketing/goodsFoster', component:() => import("@/views/marketing/goods/foster.vue"), name: '寄养',hidden: true},
						{ id:'27',path: '/marketing/goodsCard', component:() => import("@/views/marketing/goods/card.vue"), name: '卡项',hidden: true},
						{ id:'27',path: '/marketing/goodsMedical', component:() => import("@/views/marketing/goods/medical.vue"), name: '诊疗',hidden: true}

					]
				},
				// { path: '/marketing/goods', component:() => import("@/views/marketing/goods.vue"), name: '商品管理'},
				{ id:'',path: '/marketing/goods/shelvesGoods', component:() => import("@/views/marketing/goods/shelvesGoods.vue"), name: '上架商品',hidden: true},
				{ id:'',path: '/marketing/goods/shelvesService', component:() => import("@/views/marketing/goods/shelvesService.vue"), name: '上架服务',hidden: true},
				{ id:'',path: '/marketing/goods/shelvesCard', component:() => import("@/views/marketing/goods/shelvesCard.vue"), name: '上架卡项',hidden: true},
				{ id:'28',path: '/marketing/news', component:() => import("@/views/marketing/news.vue"), name: '动态管理',hidden: true},
				{ id:'',path: '/marketing/news/add', component:() => import("@/views/marketing/addNews.vue"), name: '新增动态',hidden: true},
				// { id:'',path: '/marketing/plug/discount', component:() => import("@/views/marketing/plug/discount.vue"), name: '优惠券',hidden: true},
				{ id:'',path: '/marketing/news/selectmodel', component:() => import("@/views/marketing/selectModel.vue"), name: '选择云动态',hidden: true},

			{ id:'28',path: '/marketing/evaluation/main', component:() => import("@/views/marketing/evaluation/main.vue"), name: '评价管理',hidden: true,
				children: [
					{ id:'28',path: '/marketing/evaluation/shop', component:() => import("@/views/marketing/evaluation/shop.vue"), name: '店铺评价',hidden: true},
				//	{ id:'28',path: '/marketing/evaluation/service', component:() => import("@/views/marketing/evaluation/service.vue"), name: '服务评价 ',hidden: true},
					{ id:'28',path: '/marketing/evaluation/goods', component:() => import("@/views/marketing/evaluation/goods.vue"), name: '商品评价',hidden: true}

				]
			},
		],
		hidden: true
	},
	{
		id:'8',
		path: '/shop',
		component: Home,
		name: '店务管理',
		iconCls: 'el-icon-s-shop',
		redirect: { path: '/shop/list'},
		children: [
			{ id:'30',path: '/shop/list', component:() => import("@/views/shop/shop.vue"),name: '权限管理',hidden: true},
			{ id:'',path: '/shop/list/add', component:() => import("@/views/shop/addCharacter.vue"),name: '编辑角色',hidden: true},
			{ id:'31',path: '/shop/table', component:() => import("@/views/shop/table.vue"),name: '体检表配置',hidden: true},
			{ id:'',path: '/shop/table/add', component:() => import("@/views/shop/addTable.vue"),name: '编辑体检表',hidden: true},
			{ id:'32',path: '/shop/contract', component:() => import("@/views/shop/contract.vue"),name: '寄养协议配置',hidden: true},
			{ id:'',path: '/shop/contract/add', component:() => import("@/views/shop/addContract.vue"),name: '编辑协议',hidden: true},
				// { id:'33',path: '/shop/remind', component:() => import("@/views/shop/remind.vue"),name: '服务提醒',hidden: true},
			{ id:'34',path: '/shop/bookingRules', component:() => import("@/views/shop/bookingRules.vue"),name: '预约规则',hidden: true},
			{ id:'35',path: '/shop/supplier', component:() => import("@/views/shop/supplier.vue"),name: '供应商管理',hidden: true},
			{ id:'47',path: '/shop/assistant', component:() => import("@/views/shop/assistant.vue"), name: '店务助手',hidden: true},
			{ id:'51',path: '/shop/moneySetting', component:() => import("@/views/shop/moneySetting.vue"),name: '提成设置',hidden: true},
			{ id:'48',path: '/shop/setting', component:() => import("@/views/shop/setting.vue"),name: '全局配置',hidden: true},
			{ id:'',path: '/shop/moneySetting/add', component:() => import("@/views/shop/addSetting.vue"),name: '新增提成规则',hidden: true},
		],
		hidden: true
	},
	{
		id:'9',
		path: '/setting',
		component: Home,
		name: '订购与服务',
		iconCls: 'el-icon-s-tools',
		redirect: { path: '/setting/licenseOrder' },
		children: [
			{ id:'',path: '/setting/shopSeting', component:() => import("@/views/setting/shopSeting.vue"),name: '店铺设置',hidden: true},
			{ id:'36',path: '/setting/licenseOrder', component:() => import("@/views/setting/licenseOrder.vue"),name: '软件订购',hidden: true},
			{ id:'52',path: '/setting/operateTools', component:() => import("@/views/setting/operateTools.vue"),name: '商家工具',hidden: true},
			{ id:'53',path: '/setting/contact', component:() => import("@/views/setting/contactUs.vue"),name: '联系我们',hidden: true},
			{ id:'37',path: '/setting/licenseOrderList', component:() => import("@/views/setting/licenseOrderList.vue"),name: '订购历史',hidden: true},
				// { id:'38',path: '/setting/list', component:() => import("@/views/setting/setting.vue"),name: '短信设置',hidden: true},
			{ id:'',path: '/setting/list/sign', component:() => import("@/views/setting/signSMS.vue"), name: '短信签名',hidden: true},
			{ id:'',path: '/setting/list/order', component:() => import("@/views/setting/orderSMS.vue"), name: '短信订购',hidden: true},
			{ id:'',path: '/setting/list/push', component:() => import("@/views/setting/pushSMS.vue"), name: '短信推送',hidden: true},

		],
		hidden: true
	},
    {
        id:'998',
        path: '/setting/license/paySuccess',
        component:() => import("@/views/setting/paySuccess.vue"),
        name: '订购成功',
        hidden: true
    },
	{
		id:'999',
        path: '/setting/license/:id',
        component:() => import("@/views/setting/licensePay.vue"),
        name: '订购软件',
        hidden: true
	},
	{
        path: '/',
        hidden: true,
        redirect: { path: '/login' }
	},
    {
        path: '/switch/:sign',
        component:() => import("@/views/switch.vue"),
		name:'switch_system',
        hidden: true,
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js